import Cookies from 'js-cookie';

export const checkIfUserIsAuthenticated = () => {
  return Boolean(Cookies.get("isAuthenticated") || false);
}